import React from 'react';
import { ActivityIndicator, ScrollView, StyleSheet, View } from 'react-native';
import { connect } from 'react-redux';
import Theme from '../../../theme';
import { defaultScale } from '../../../utils/scaling';
import { closeSetupScreen } from '../../actions';
import { orientationSelector } from '../../selectors';
import { DeviceSetupSubScreenHeader } from '../DeviceSetup/DeviceSetupSubScreenHeader';
import { IPlaylist, ISong } from './interfaces';
import MusicControlSection from './MusicControlSection';
import { MusicPlayerHeaderNavigation } from './MusicPlayerHeaderNavigation';
import {
  getSelectedPlaylistSelector,
  getSongsLoadingStateSelector,
  getSongsSelector,
} from './selectors';
import { SongListItem } from './SongListItem';

interface IProps {
  songs: ISong[];
  songsLoading: boolean;
  orientation: string;
  closeSetupScreen: () => void;
  selectedPlaylist: IPlaylist | null;
  t: (key: string, options?: any) => string;
}

class MusicPlayerComponent extends React.PureComponent<IProps> {

  public portrait = (): boolean => {
    return this.props.orientation === 'PORTRAIT';
  }

  public render() {
    const { songs } = this.props;
    return (
      <>
        <DeviceSetupSubScreenHeader
          title={`Playing ${this.props.selectedPlaylist ? this.props.selectedPlaylist.title : 'playlist'}`}
          onBackPress={this.props.closeSetupScreen}
          headerRightComponent={!this.portrait() && <MusicPlayerHeaderNavigation t={this.props.t} />}
        />
        <View style={{ marginTop: defaultScale(10), flex: 1 }}>
          {
            this.props.songsLoading &&
            <View style={{ flex: 1, justifyContent: 'center', alignItems: 'center' }}>
              <ActivityIndicator
                size='large'
                animating={true}
                color={Theme.PRIMARY}
              />
            </View>
          }
          {
            !this.props.songsLoading &&
            <View style={{ flex: 1, flexDirection: this.portrait() ? 'column-reverse' : 'row' }}>
              <View style={{ flex: this.portrait() ? 5 : 1 }}>
                <ScrollView>
                  {songs.map((item, index) => (
                    <SongListItem playlistItem={item} key={item.uri} index={index} />
                  ))}
                </ScrollView>
              </View>
              <View style={{ flex: this.portrait() ? 7 : 1 }}>
                {
                  this.portrait() &&
                  <MusicPlayerHeaderNavigation t={this.props.t} />
                }
                <MusicControlSection />
              </View>
            </View>
          }
        </View>
      </>
    );
  }
}

const mapStateToProps = (state: any): Partial<IProps> => {
  return {
    songs: getSongsSelector(state),
    songsLoading: getSongsLoadingStateSelector(state),
    orientation: orientationSelector(state),
    selectedPlaylist: getSelectedPlaylistSelector(state),
  };
};

const mapDispatchToProps = (dispatch: any): Partial<IProps> => {
  return {
    closeSetupScreen: () => dispatch(closeSetupScreen()),
  };
};

export const MusicPlayer = connect(mapStateToProps, mapDispatchToProps)(MusicPlayerComponent);
